import { Controller } from '@hotwired/stimulus'
import Hls from 'hls.js'

export default class extends Controller {
    static values = {
        src: String,
    }

    connect() {
        if (this.canPlayNativeHls()) {
            this.element.src = this.srcValue
        } else if (Hls.isSupported()) {
            this.initHlsJs()
        } else {
            console.warn('Stimulus HLS: HLS not supported in this browser.')
        }

        this.element.play().catch(() => {})
    }

    canPlayNativeHls() {
        return this.element.canPlayType('application/vnd.apple.mpegurl')
    }

    initHlsJs() {
        const hls = new Hls({ autoStartLoad: true })
        hls.loadSource(this.srcValue)
        hls.attachMedia(this.element)
    }
}
